// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__11N1c","header":"Title_header__1tMax","withBorder":"Title_withBorder__2ER0s"};